import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/commonUtils';
import '../../../styles/LtsContentView.css';
import { LiveTrainStatusContext } from '../LiveTrainStatus';
import { formatDateForLtsDatePicker } from '../utils/ltsCardDetailsUtils';
import { getDateObjectFromDetails } from '../utils/commonLtsUtils';
import LtsContentViewListItem from './LtsContentViewListItem';
import { LTS_CONTENT_VIEW } from '../constants/LtsConstants';

function LtsContentView({ customClass }) {
  const isMobileDevice = isMobile();
  const { ltsPageState } = useContext(LiveTrainStatusContext);
  const { haltingStationCollection, trainStartDate, isLoading } = { ...ltsPageState };
  let recentMostDate =
    trainStartDate &&
    formatDateForLtsDatePicker(getDateObjectFromDetails({ dateInString: trainStartDate, timeInString: '00:00:00' }));

  const { DISTANCE, STATION_NAME, STARTING_POINT, END_POINT } = LTS_CONTENT_VIEW;
  return (
    <div className={`${isLoading ? 'ltsContentViewLoading' : ''} ltsContentView`}>
      <div className="ltsContentView__header">
        <span className="stationDistance">{DISTANCE}</span>
        <span>{STATION_NAME}</span>
        <span className={'pushRight appendRight30'}>{!isMobileDevice ? 'Scheduled' : 'Sched.'}</span>
        <span className={`${!isMobileDevice ? '' : 'appendRight10'}`}>{!isMobileDevice ? 'Actual' : 'Expt.'}</span>
      </div>
      <span className="startingDate">{recentMostDate}</span>
      <span className="pointLabel">{STARTING_POINT}</span>
      <ul>
        {haltingStationCollection &&
          haltingStationCollection.map((haltingStation, index) => (
            <LtsContentViewListItem haltingStationIndex={index} />
          ))}
      </ul>
      {<span className="pointLabel  pointLabel--end">{END_POINT}</span>}
    </div>
  );
}

LtsContentView.propTypes = {
  customClass: PropTypes.string
};

export default LtsContentView;
